var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShezhi2Xian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.163 7.11a4.86 4.86 0 000 1.78l-1.436.823a.26.26 0 00-.095.356l1.378 2.365a.26.26 0 00.354.095l1.438-.824c.46.39.988.693 1.558.894v1.641c0 .144.117.26.26.26h2.76a.26.26 0 00.26-.26v-1.641c.57-.2 1.098-.504 1.557-.894l1.44.824a.26.26 0 00.353-.095l1.378-2.365a.26.26 0 00-.095-.356l-1.436-.822a4.86 4.86 0 000-1.782l1.436-.822a.26.26 0 00.095-.356L12.99 3.566a.26.26 0 00-.354-.095l-1.438.824a4.953 4.953 0 00-1.558-.894V1.76a.26.26 0 00-.26-.26H6.62a.26.26 0 00-.26.26v1.641a4.954 4.954 0 00-1.558.894l-1.438-.824a.26.26 0 00-.354.095L1.632 5.93a.26.26 0 00.095.356l1.436.822z",
    stroke: "#6F7485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8a2.75 2.75 0 11-5.5 0 2.75 2.75 0 015.5 0z",
    stroke: "#6F7485"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shezhi2_xian.c89fc93f.svg";
export { SvgTongyongShezhi2Xian as ReactComponent };